import moment from 'moment';

export const formatDate = (date: any) => {
  const returnDate = moment(date).format('MMMM DD, YYYY');
  return returnDate;
};
